<template>
  <div class="blog-page">
    <div class="blog-content">
      <div class="header">
        <span style="color:#a8acb0"> {{ translateTitle("首页") }} / </span>
        <span style="color:#15192a"> {{ translateTitle("博客") }}</span>
      </div>
      <div class="banner-content">
        <div class="left">
          <div class="banner-content">
            <img
              @click="onBannerImgClick"
              class="banner-img"
              :src="bannerList[bannerIndex].language[`img_url_${language}`]"
              alt=""
            />
            <img
              @click="onLeftBtnClick"
              class="left-btn"
              src="../../assets/img/mask/blog/left-btn.png"
              alt=""
            />
            <img
              @click="onRightBtnClick"
              class="right-btn"
              src="../../assets/img/mask/blog/right-btn.png"
              alt=""
            />
          </div>
          <div class="blog-list-content" v-if="blogList.length > 0">
            <div
              class="blog-item"
              v-for="(item, index) in blogList"
              @click="onItemClcik(item.pid)"
              :key="index"
            >
              <img class="list-img" :src="item.img_url" alt="" />
              <div class="list-item-content">
                <p class="title">
                  {{ item.title }}
                </p>
                <div class="content">
                  {{ item.content }}
                </div>
                <div class="time">
                  {{ timestamp(item.create_time) }}
                </div>
              </div>
            </div>
          </div>
          <no-data v-else slot="empty"></no-data>
        </div>
        <div class="right">
          <el-input
            class="search-input"
            :placeholder="translateTitle('搜索')"
            @keyup.enter.native="getBlogList"
            v-model="searchInput"
          >
            <i slot="append" @click="getBlogList" class="el-icon-search"></i>
          </el-input>
          <div class="tag-content">
            <p class="tag-title">{{ translateTitle("Tags") }}</p>
            <div class="tags">
              <span
                class="tag-item"
                :class="activeTag == item.tag_id ? 'active' : ''"
                v-for="(item, index) in tagList"
                @click="onTagClick(item.tag_id)"
                :key="index"
                >{{ item.content }}</span
              >
            </div>
          </div>
          <div class="tag-content">
            <p class="tag-title">{{ translateTitle("Follow us") }}</p>
            <div class="icon-content">
              <ul>
                <li style="margin-left:0">
                  <a
                    href="https://www.facebook.com/maskexglobal"
                    target="_blank"
                  >
                    <img src="../../assets/img/mask/blog/facebook.png" alt="" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://mobile.twitter.com/MaskexGlobal"
                    target="_blank"
                  >
                    <img src="../../assets/img/mask/blog/twitter.png" alt="" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/maskexglobal/"
                    target="_blank"
                  >
                    <img
                      src="../../assets/img/mask/blog/instagram.png"
                      alt=""
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UClSeew7MEmHi6i19GBEun9w"
                    target="_blank"
                  >
                    <img src="../../assets/img/mask/blog/youtube.png" alt="" />
                  </a>
                </li>
                <li>
                  <a href="https://t.me/maskextg" target="_blank">
                    <img src="../../assets/img/mask/blog/telegram.png" alt="" />
                  </a>
                </li>
                <li>
                  <a href="https://vm.tiktok.com/ZSeEMpTqm" target="_blank">
                    <img src="../../assets/img/mask/blog/tiktok.png" alt="" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://am.linkedin.com/company/maskex-global"
                    target="_blank"
                  >
                    <img src="../../assets/img/mask/blog/linkedin.png" alt="" />
                  </a>
                </li>
                <li>
                  <a href="https://discord.gg/maskex" target="_blank">
                    <img src="../../assets/img/mask/blog/discord.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="hot-list">
            <p class="hot-title">{{ translateTitle("Popular Posts") }}</p>
            <ul class="hot-content">
              <li
                class="hot-item"
                v-for="(item, index) in hotList"
                :key="index"
                @click="onItemClcik(item.pid)"
              >
                <div class="left-item">
                  <img class="hot-img" :src="item.img_url" alt="" />
                </div>
                <div class="right-item">
                  <p class="hot-text">
                    {{ item.title }}
                  </p>
                  <p>{{ timestamp(item.create_time) }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { timestampToYear, timestamp } from "@/assets/js/formatDate";
import commonMixin from "@/components/common/commonMixin.vue";
import routeSplicing from "@/assets/js/routeSplicing";
import NoData from "@/components/common/NoData";
import {
  apiGetBlogList,
  apiGetTags,
  apiGetHotList,
  apiGetBanner,
} from "@/model/blog/index";
export default {
  mixins: [commonMixin],
  components: { NoData },
  data() {
    return {
      searchInput: "",
      bannerIndex: 0,
      tagId: "",
      activeTag: "",
      bannerList: [],
      blogList: [],
      hotList: [],
      tagList: [],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
      language: "user/language",
      environment: "user/environment",
      darkMode: "user/darkMode",
    }),
  },
  created() {
    this.getBanner();
    this.getTags();
    this.getBlogList();
    this.getHotList();
  },
  methods: {
    routeSplicing,
    timestamp,
    onBannerImgClick() {
      window.open(
        this.bannerList[this.bannerIndex].language[`url_${this.language}`]
      );
    },
    onLeftBtnClick() {
      this.bannerIndex--;
      if (this.bannerIndex <= 0) {
        this.bannerIndex = 0;
      }
    },
    onRightBtnClick() {
      this.bannerIndex++;
      if (this.bannerIndex >= this.bannerList.length) {
        this.bannerIndex = this.bannerList.length;
      }
    },
    onItemClcik(pid) {
      this.$router.push({
        path: this.routeSplicing(this.language, "blogDetail"),
        query: { pid: pid },
      });
    },
    onTagClick(item) {
      this.activeTag = item;
      this.getBlogList();
    },
    getBlogList() {
      const req = {
        search: this.searchInput,
        tag_id: this.activeTag,
      };
      apiGetBlogList(req).then(res => {
        if (res.status == 200) {
          this.blogList = res.data.list;
        }
      });
    },
    getTags() {
      apiGetTags().then(res => {
        if (res.status == 200) {
          this.tagList = res.data;
          this.activeTag = this.tagList[0].tag_id;
        }
      });
    },
    getHotList() {
      apiGetHotList().then(res => {
        if (res.status == 200) {
          this.hotList = res.data;
        }
      });
    },
    getBanner() {
      apiGetBanner().then(res => {
        if (res.status == 200) {
          this.bannerList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.blog-page {
  background: #f9f9f9;
}
.blog-content {
  width: 1200px;
  margin: 0 auto;
  .header {
    user-select: none;
    padding-top: 40px;
    margin-bottom: 27px;
  }
  .banner-content {
    position: relative;
    .left-btn {
      width: 44px;
      height: 56px;
      position: absolute;
      bottom: 30px;
      right: 90px;
      cursor: pointer;
    }
    .right-btn {
      width: 44px;
      height: 56px;
      position: absolute;
      bottom: 30px;
      right: 30px;
      cursor: pointer;
    }
    .left {
      vertical-align: top;
      display: inline-block;
      width: 790px;
      .no-data-box {
        background: #f9f9f9;
        min-height: 900px;
      }
      .banner-img {
        width: 790px;
        height: 445px;
        border-radius: 8px;
      }
      .blog-list-content {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 115px;
        .blog-item {
          background: #fff;
          width: 380px;
          cursor: pointer;
          border-radius: 5px;
          box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.02);
          //   height: 445px;
          margin-bottom: 33px;
          .list-img {
            width: 380px;
            height: 213.6px;
          }
          .list-item-content {
            padding: 10px 20px 12px;
            .title {
              font-size: 20px;
              color: #15192a;
              font-weight: bold;
              margin-bottom: 12px;
            }
            .content {
              font-size: 16px;
              min-height: 66px;
              color: #666;
              display: -webkit-box;
              display: -moz-box;
              white-space: pre-wrap;
              word-wrap: break-word;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
            .time {
              margin-top: 40px;
              color: #666;
            }
          }
        }
      }
    }
    .right {
      margin-left: 60px;
      width: 350px;
      vertical-align: top;
      display: inline-block;
      .search-input {
        width: 350px;
        height: 53.8px;
        padding: 10px 30px 10px 25px;
        border-radius: 37px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.02);
        border: solid 0.6px #f0f2f5;
        background-color: #fff;
        .el-input-group__append {
          background-color: white;
          border: none;
          padding: 0;
          cursor: pointer;
        }
        .el-input__inner {
          border: none;
          margin-top: -4px;
          font-size: 18px;
        }
        .el-icon-search {
          font-size: 20px;
          margin-right: 10px;
        }
      }
      .tag-content {
        margin-top: 30px;
        .tag-title {
          font-size: 18px;
          color: #15192a;
          font-weight: bold;
          height: 25px;
          margin-bottom: 22px;
        }
        .tags {
          width: 350px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .tag-item {
            cursor: pointer;
            height: 38px;
            flex-grow: 0;
            margin: 0 20px 18.5px 0;
            padding: 10px 13px;
            border-radius: 3px;
            background-color: #f1f1f1;
            color: #999;
            font-size: 14px;
            font-weight: 500;
            &.active {
              color: #15bfb5;
              background-color: #e3f6f5;
            }
          }
        }
        .icon-content {
          width: 350px;
          margin-bottom: 75px;
          ul li {
            margin-left: 27px;
            display: inline-block;
            img {
              cursor: pointer;
              height: 20px;
            }
          }
        }
      }
      .hot-list {
        .hot-title {
          font-size: 18px;
          color: #15192a;
          font-weight: bold;
          height: 25px;
          margin-bottom: 22px;
        }
        .hot-content {
          .hot-item {
            cursor: pointer;
            margin-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #eee;
            .left-item {
              display: inline-block;
              vertical-align: top;
              .hot-img {
                width: 120px;
                height: 67.7px;
              }
            }
            .right-item {
              margin-left: 15px;
              display: inline-block;
              vertical-align: top;
              p {
                width: 214px;
                color: #999;
                font-size: 13px;
              }
              .hot-text {
                height: 43px;
                margin-bottom: 10px;
                font-size: 16px;
                color: #15192a;
                display: -webkit-box;
                display: -moz-box;
                white-space: pre-wrap;
                word-wrap: break-word;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
            }
          }
        }
      }
    }
  }
}
</style>
